<template>
  <div  class="item-box">
     <span class="btns" v-if="isBtns">
        <span>
          <b-form-checkbox class="custom-control-inline custom-add"  v-model = "isAdd" :disabled="isOmit" data-test="demo-businessType-item-add"/>
        </span>
        <span><b-form-checkbox class="custom-control-inline" v-model = "isOmit" :disabled="isAdd" data-test="demo-businessType-item-omit"/></span>
      </span>
      <span class="btns-block"  v-if="!isBtns&&!isExpand">
      </span>
    <span class="btns"  v-if="!isBtns&&isExpand">
          <span>
          <b-form-checkbox class="custom-control-inline"  v-model = "isAllAdd" :disabled="isAllOmitTemple" data-test="demo-businessType-item-add"/>
          </span>
          <span><b-form-checkbox class="custom-control-inline" v-model = "isAllOmit" :disabled="isAllAddTemple" data-test="demo-businessType-item-omit"/></span>
      </span>
    <span @click="select"
          class="item"
          :style="{'margin-left': 16 * deep + 'px'}" data-test="demo-businessType-item">
      <span v-show = "!isClose">
        <span  v-if="!isExpand"
               @click = "shrink"
               class="item-btn"
               data-test="demo-businessType-item-shrink">
          <icon name="folder" class="fold-icon"></icon>
        </span>
        <span v-if="isExpand"
              @click = "expand"
              class="item-btn"
              data-test="demo-businessType-item-expand">
          <icon name="folder-open" class="fold-icon"></icon>
        </span>
      </span>
      <span v-show="isClose" class="icon-close" data-test="demo-businessType-item-expand2">
        <icon name="file" class="fold-icon"></icon>
      </span>

      <span @click = "expand" data-test="demo-businessType-item-expand3">{{item.data}}</span>
    </span>

    <business-type-item v-if = "values.length > 0 && isExpand"
                        v-for= "val in values"
                        :item = "val"
                        :key="val.data" :deep="thisDeep"/>
  </div>
</template>

<script>
  export default {
    name: 'businessTypeItem',
    props: {
      item: {
        type: Object
      },
      deep: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        isExpand: false,
        thisDeep: 0,
        isAllAddTemple: false,
        isAllOmitTemple: false
      }
    },
    computed: {
      listType () {
        if (this.$store.state.order.ListType) {
          return this.$store.state.order.ListType
        } else {
          return 10
        }
      },
      values () {
        if (this.item.val) {
          return this.item.val
        } else {
          return []
        }
      },
      isClose () {
        return this.item.state === ''
      },
      isBtns () {
        return this.deep !== 0
      },
      isAdd: {
        get () {
          return this.$store.getters['order/isDemoBusinessTypeAdd'](this.item.attributes.IndustryCode)
        },
        set (val) {
          if (val === this.isAdd) {
            return
          }
          this.$store.dispatch('order/toggleAddDemoBusinessType', {
            val,
            industryCode: this.item.attributes.IndustryCode,
            IndustryDesc: this.item.data,
            values: this.values
          })
        }
      },
      isOmit: {
        get () {
          return this.$store.getters['order/isDemoBusinessTypeOmit'](this.item.attributes.IndustryCode)
        },
        set (val) {
          if (val === this.isOmit) {
            return
          }
          this.$store.dispatch('order/toggleOmitDemoBusinessType', {
            val,
            industryCode: this.item.attributes.IndustryCode,
            IndustryDesc: this.item.data,
            values: this.values
          })
        }
      },
      isAllAdd: {
        get () {
          return this.isAllAddTemple
        },
        set (val) {
          this.$store.dispatch('order/toggleAddDemoBusinessType', {
            val,
            industryCode: this.item.attributes.IndustryCode,
            IndustryDesc: this.item.data,
            deep: 0,
            values: this.values
          })
          this.isAllAddTemple = val
        }
      },
      isAllOmit: {
        get () {
          return this.isAllOmitTemple
        },
        set (val) {
          this.$store.dispatch('order/toggleOmitDemoBusinessType', {
            val,
            industryCode: this.item.attributes.IndustryCode,
            IndustryDesc: this.item.data,
            deep: 0,
            values: this.values
          })
          this.isAllOmitTemple = val
        }
      }
    },
    mounted () {
      this.thisDeep = this.deep + 1
    },
    methods: {
      select () {
        if (this.isExpand) {
          this.isExpand = false
        } else if (!this.isExpand) {
          this.isExpand = true
          this.expand()
        }
      },
      shrink () {
        this.isExpand = false
      },
      expand () {
        this.isExpand = true
        if (this.values.length > 0) {
          return
        }
        this.$http.post('PlaceOrder.aspx/GetChildrenBySICCode', {
          id: this.item.attributes.IndustryCode,
          listType: this.listType
        }).then(resp => {
          let val = resp.body.d.DataSource
          for (let i = 0; i < val.length; i++) {
            let datas = val[i].data.split('\n')
            val[i].data = datas[0]
          }
          this.$set(this.item, 'val', val)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .all-hosehodls {
    margin-top: 16px;
  }
  .item-box {
    /*margin-left: 16px;*/
    position: relative;
    display: block;
  }
  .item-btn {
    padding-right: 16px;
    padding-left: 16px;
    color: $color-primary;
    font-size: 0.9em;
  }
  .icon-close {
    margin-left: 32px;
    margin-right: 16px;
  }
  .item {
    margin-bottom: 16px;
  }
  .btns {
    margin-left: 16px;
    padding-top: 4px;
  }
  .btns-block {
    display: inline-block;
    width: 80px;
  }
  .custom-checkbox {
    min-height: 1rem;
  }

  .fold-icon {
    vertical-align: sub;
  }
  .custom-control-input:checked ~ .custom-control-label::before{
    border-color: green!important;
    background-color: green!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/BusinessTypeItem.vue